import {_RecursosEndpoints} from "@localization/siteMap/endpoints/_RecursosEndpoints.ts";
import {IRecurso} from "@models/recurso/IRecurso.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import type {IRecursoFiltroDto} from "@models/recurso/dto.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {ICreateRecursoDto} from "@components/recurso/models/dto/ICreateRecursoDto.ts";
import {__recurso_endpoints} from "@components/recurso/endpoints/__recurso_endpoints.ts";
import {useValue} from "@components/shared/hooks/useValue.tsx";
import {IRecursoParamDto} from "@components/recurso/models/dto/IRecursoParamDto.ts";

export function useRecurso() {
	const {Get} = useApi()
	const {createAlertFromResponse} = useAlert()

	const getRecurso = async (id: number) => {
		return Get(_RecursosEndpoints.GetRecurso({ids: [id]}, {page: 1, pageSize: 1}))
	}

	const getRecursos = (data: { filter: IRecursoFiltroDto, pagination: IPagination }) => {
		return Get(_RecursosEndpoints.GetRecurso(data.filter, data.pagination))
	}

	const updateRecurso = async (rec: IRecurso) => {
		return Get(_RecursosEndpoints.UpdateRecurso(rec)).then(x => {
			createAlertFromResponse(x)
			return x.items
		})
	}

	const updateParametros = async (data: { idRecurso: number, parametros: IRecursoParamDto[] }) => {
		return Get(__recurso_endpoints.v2["update-parametros"]({
			data: {
				recursoId: data.idRecurso,
				parametros: data.parametros
			}
		}))
	}

	const importRecursos = async (recursos: IDataNoPageDto<ICreateRecursoDto[]>) => {
		return Get(_RecursosEndpoints.ImportarRecursos(recursos))
	}

	const getDetalhes = (data: IDataNoPageDto<{ recursoId: number }>) => {
		return Get(__recurso_endpoints.v2["get-detalhes"](data))
	}

	const useRecursoValue = (data?: IRecurso | number) => {
		return useValue({
			value: data,
			getter: () => getRecurso(typeof data === 'number' ? data : data?.id ?? 0)
		})
	}


	return ({
		getRecurso: getRecurso,
		getRecursos: getRecursos,
		updateRecurso: updateRecurso,
		importRecursos: importRecursos,
		useRecursoValue: useRecursoValue,
		updateParametros: updateParametros,
		getDetalhes: getDetalhes
	})
}